export default __webpack_public_path__ + "static/media/infoIcon.ecde53e7.svg";